import { action, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import { ExportLabelsForm } from 'modules/order/forms';
import { lookupRouteName } from 'common/constants';
import { notificationError } from 'core/utils';
import { createFileUrl } from 'core/utils';
import moment from 'moment';
import * as printJS from 'print-js';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';
import { LookupStore } from 'modules/lookup/stores';

class ExportLabelsViewStore extends BaseViewStore {
	form = new ExportLabelsForm();

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.shipmentInfoStore = new ShipmentInfoStore(this.rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		this.carrierTypeServiceTypeDropdownStore = new BaasicDropdownViewStore({
			field: this.form.$('carrierTypeServiceTypeId'),
			lookupRoute: lookupRouteName.carrierTypeServiceType,
			store: new LookupStore(this.rootStore),
		});
		this.resume();
	};

	@action.bound
	exportLabels = async () => {
		try {
			const response = await this.shipmentInfoStore.exportLabels(
				this.carrierTypeServiceTypeDropdownStore.value.extra.carrierTypeId,
				this.carrierTypeServiceTypeDropdownStore.value.extra.carrierServiceTypeId,
				moment().format()
			);
			if (response.data != null) {
				const fileURL = createFileUrl(response.data);
				printJS(fileURL);
				this.modalParams.close();
			} else {
				this.rootStore.notificationStore.error('FULFILLMENTORDERVIEW.NOLABELSTOEXPORT');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	};
}

export default ExportLabelsViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/ExportLabelsViewStore.js